// extracted by mini-css-extract-plugin
module.exports = {"comp":"Section_comp__QD9bQ"};